<template>
  <div class="markItem">
    <div class="three-content" v-if="isShowThree">
      <div class="one-text text-w">{{ getValue(model.num1) }}</div>
      <div class="two-text text-w">{{ getValue(model.num2) }}</div>
      <div class="three-text text-w" :style="{ backgroundColor: getColor() }">
        {{ compareValue }}
      </div>
    </div>
    <div class="one-content" v-else>
      {{ getValue(model.num1) }}
    </div>
  </div>
</template>
<script>
export default {
  name: "markItem",
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    isShowThree: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    getValue(num) {
      if (num) {
        return num;
      }
      return "-";
    },
    getColor() {
      if (!this.model.num1 || !this.model.num2) {
        return "#999999";
      } else {
        if (parseFloat(this.model.num1) > parseFloat(this.model.num2)) {
          return "#F18B8B";
        }
        return "#AEDFA9";
      }
    },
  },
  computed: {
    compareValue() {
      if (this.model.num1 && this.model.num2) {
        const comValue = 1 - (this.model.num1 / this.model.num2)
        let valueStr = ''
        if (comValue == 0) {
          valueStr = (comValue*100) + "%"
        } else {
          valueStr = (comValue*100).toFixed(1) + "%"
        }
        
        return valueStr
      }
      return "-"
    }
  },
  created() {},
  components: {},
};
</script>
<style lang='less' scoped>
.markItem {
  cursor: pointer;
}

.one-content {
  width: 150px;
  height: 60px;
  color: #707070;
  font-size: 18px;
  background-color: #fff;
  border-width: 0.5px;
  border-style: solid;
  border-color: #707070;
  display: flex;
  justify-content: center;
  align-items: center;
  word-break:break-all;
  
}

.three-content {
  display: flex;
  flex-direction: row;
  background-color: #fff;
  border-width: 0.5px;
  border-style: solid;
  border-color: #707070;
  height: 60px;
}

.text-w {
  width: 49.3px;
  // height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  word-break: break-word;
}
.one-text {
  color: #707070;
  font-size: 12px;
  background-color: #fff;
}

.two-text {
  color: #707070;
  font-size: 12px;
  background-color: #eeeeee;
}

.three-text {
  color: #fff;
  font-size: 12px;
}
</style>